import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FeedbackAlert } from '../../atomic/feedback/alert';
import { walletErrorCopy } from './walletErrorCopy';

type Props = {
  error: unknown;
  onRetry: () => void;
  titleKey?: string;
  notFoundMeansNoAccount?: boolean;
};

/** A failed wallet query, in words that match the failure, with a way to try again where that can help. */
export const WalletLoadError: FC<Props> = ({
  error,
  onRetry,
  titleKey,
  notFoundMeansNoAccount
}) => {
  const { t } = useTranslation();
  const copy = walletErrorCopy(error, { titleKey, notFoundMeansNoAccount });

  return (
    <FeedbackAlert
      severity="error"
      title={t(copy.titleKey)}
      description={t(copy.textKey)}
      actionText={copy.retryable ? t('pxtraCard:retry') : undefined}
      actionCallback={copy.retryable ? onRetry : undefined}
    />
  );
};
